import {PolyDictionary} from '../../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {Ref} from 'vue';
import {BaseCodeDisplayer} from './_Base';
import type {TetSoftBodySolverSopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/TetSoftBodySolver';

export class FunctionDataVelocityColliderCodeDisplayer {
	static async update(
		node: TetSoftBodySolverSopNode,
		shadersByName: Ref<PolyDictionary<string | null>>,
		shaderNames: Ref<string[]>
	) {
		await node.compute();
		BaseCodeDisplayer.clear(shadersByName, shaderNames);
		const codeVelocity = node.functionData()?.functionBody.velocity;
		const codeCollider = node.functionData()?.functionBody.collider;
		shadersByName.value['velocity'] = codeVelocity || '';
		shadersByName.value['collider'] = codeCollider || '';
		shaderNames.value.push('velocity');
		shaderNames.value.push('collider');
	}
}
